// Copyright (c) 2021 Deere & Company

export default Object.freeze({
    IS_DEALERSHIP_MODAL_VISIBLE: 'IS_DEALERSHIP_MODAL_VISIBLE',
    RESET_CLAIM_DEALER_DETAILS: 'RESET_CLAIM_DEALER_DETAILS',
    SET_SELECTED_ACCOUNT_LABOR_RATES: 'SET_SELECTED_ACCOUNT_LABOR_RATES',
    UPDATE_MASS_LABOR_RATE_AVERAGE_TECH_PAY_RATE: 'UPDATE_MASS_LABOR_RATE_AVERAGE_TECH_PAY_RATE',
    UPDATE_MASS_LABOR_RATE_COMMENT: 'UPDATE_MASS_LABOR_RATE_COMMENT',
    UPDATE_MASS_LABOR_RATE_EFFECTIVE_DATE: 'UPDATE_MASS_LABOR_RATE_EFFECTIVE_DATE',
    UPDATE_MASS_LABOR_RATE_FILE: 'UPDATE_MASS_LABOR_RATE_FILE',
    UPDATE_MASS_LABOR_RATE_REQUESTED_RATE: 'UPDATE_MASS_LABOR_RATE_REQUESTED_RATE'
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/actions-list.js